import { Sparkles } from "lucide-react";

export const SiteHeader = ({ onBook }) => {
  return (
    <header
      className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-border"
      data-testid="site-header"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2" data-testid="brand-logo">
          <span className="h-9 w-9 rounded-xl bg-primary flex items-center justify-center">
            <Sparkles className="h-5 w-5 text-primary-foreground" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading font-bold text-lg tracking-tight text-primary">
              Nexo AI Lab
            </span>
            <span className="font-heading font-light text-xs text-primary">
              Conectando negocios con IA
            </span>
          </span>
        </a>
        <button
          onClick={onBook}
          data-testid="header-book-call-btn"
          className="bg-accent text-accent-foreground px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-accent/90 transition-colors"
        >
          Agenda una llamada gratis de 15 min
        </button>
      </div>
    </header>
  );
};
